export default [
  { name: 'Name', prop: 'name', type: 'text' },
  { name: 'Session', prop: 'session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name' },
  { name: 'All coaches group', prop: 'is_coaches', type: 'checkbox' }
]
